// helpers.ts — Pure utility functions for P9207 (Resignation Request) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Derive the approval status for display */
export const getApprovalStatus = (record: { f90k_80?: string; f90k_61?: string; f90k_71?: string; f90k_76?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  switch (record.f90k_80) {
    case 'P': return { text: '已核准', cls: 'badge-success' };
    case 'X': return { text: '已離職', cls: 'badge-danger' };
    default: return { text: '待審', cls: 'badge-warning' };
  }
};

/** Check if any approval has been given (locks modify/delete) */
export const isApprovalLocked = (record: { f90k_61?: string; f90k_71?: string; f90k_76?: string } | null): boolean => {
  if (!record) return false;
  return !!(
    (record.f90k_61 && record.f90k_61.trim()) ||
    (record.f90k_71 && record.f90k_71.trim()) ||
    (record.f90k_76 && record.f90k_76.trim())
  );
};

/** Display value for optiongroup Y/N/blank */
export const approvalLabel = (val: string | undefined): string => {
  if (!val || !val.trim()) return '-';
  return val.trim() === 'Y' ? 'Y (核准)' : 'N (不准)';
};

/** Fields that are always readonly (never editable) */
const ALWAYS_READONLY = new Set([
  'f90k_01', // 單號
  'f90k_11', // 員工代號
  'f90k_12', // 申請日期
  'f90k_21', // 部門
  'f90k_22', // 職稱
  'f90k_23', // 到職日
  // Page2 全部唯讀
  'f90k_56', 'f90k_61', 'f90k_62', 'f90k_63',
  'f90k_66', 'f90k_67', 'f90k_68',
  'f90k_71', 'f90k_72', 'f90k_73',
  'f90k_76', 'f90k_77', 'f90k_78',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};
